// Generated by server/scripts/generate-skilljobmap.mjs from the `roseon`.`list_skills`
// DB table (original game data, imported alongside npc_data -- see CLAUDE.md's list_skills
// gotcha). Not derivable from LIST_SKILL.STB alone; classid there encodes job (111=Soldier,
// 211=Muse, 311=Hawker, 411=Dealer, plus 0=Special, 2=GM Skills, 3=Basic; classid=1 is inactive
// dev-only junk and is excluded). Regenerate with:
//   node server/scripts/generate-skilljobmap.mjs --yes

export const SKILL_JOB_CATEGORY: { [skillIdx: number]: string } = {
  11: 'Basic',
  12: 'Basic',
  13: 'Basic',
  14: 'Basic',
  15: 'Basic',
  16: 'Basic',
  17: 'Basic',
  18: 'Basic',
  19: 'Basic',
  20: 'Basic',
  25: 'Basic',
  26: 'Basic',
  27: 'Basic',
  28: 'Basic',
  29: 'Basic',
  30: 'Basic',
  31: 'Basic',
  32: 'Basic',
  33: 'Basic',
  50: 'Basic',
  101: 'Basic',
  201: 'Soldier',
  202: 'Soldier',
  203: 'Soldier',
  204: 'Soldier',
  205: 'Soldier',
  206: 'Soldier',
  207: 'Soldier',
  208: 'Soldier',
  209: 'Soldier',
  211: 'Soldier',
  212: 'Soldier',
  213: 'Soldier',
  214: 'Soldier',
  215: 'Soldier',
  216: 'Soldier',
  217: 'Soldier',
  218: 'Soldier',
  219: 'Soldier',
  221: 'Soldier',
  222: 'Soldier',
  223: 'Soldier',
  224: 'Soldier',
  225: 'Soldier',
  226: 'Soldier',
  227: 'Soldier',
  228: 'Soldier',
  229: 'Soldier',
  231: 'Soldier',
  232: 'Soldier',
  233: 'Soldier',
  234: 'Soldier',
  235: 'Soldier',
  236: 'Soldier',
  237: 'Soldier',
  238: 'Soldier',
  239: 'Soldier',
  240: 'Soldier',
  241: 'Soldier',
  242: 'Soldier',
  243: 'Soldier',
  244: 'Soldier',
  245: 'Soldier',
  246: 'Soldier',
  247: 'Soldier',
  248: 'Soldier',
  249: 'Soldier',
  251: 'Soldier',
  252: 'Soldier',
  253: 'Soldier',
  254: 'Soldier',
  255: 'Soldier',
  256: 'Soldier',
  257: 'Soldier',
  258: 'Soldier',
  259: 'Soldier',
  269: 'Soldier',
  271: 'Soldier',
  272: 'Soldier',
  273: 'Soldier',
  274: 'Soldier',
  275: 'Soldier',
  276: 'Soldier',
  277: 'Soldier',
  278: 'Soldier',
  279: 'Soldier',
  281: 'Soldier',
  282: 'Soldier',
  283: 'Soldier',
  284: 'Soldier',
  285: 'Soldier',
  286: 'Soldier',
  287: 'Soldier',
  288: 'Soldier',
  289: 'Soldier',
  291: 'Soldier',
  292: 'Soldier',
  293: 'Soldier',
  294: 'Soldier',
  295: 'Soldier',
  296: 'Soldier',
  297: 'Soldier',
  298: 'Soldier',
  299: 'Soldier',
  301: 'Soldier',
  302: 'Soldier',
  303: 'Soldier',
  304: 'Soldier',
  305: 'Soldier',
  306: 'Soldier',
  307: 'Soldier',
  308: 'Soldier',
  309: 'Soldier',
  310: 'Soldier',
  311: 'Soldier',
  312: 'Soldier',
  313: 'Soldier',
  314: 'Soldier',
  316: 'Soldier',
  317: 'Soldier',
  318: 'Soldier',
  319: 'Soldier',
  320: 'Soldier',
  321: 'Soldier',
  322: 'Soldier',
  323: 'Soldier',
  324: 'Soldier',
  326: 'Soldier',
  327: 'Soldier',
  328: 'Soldier',
  329: 'Soldier',
  330: 'Soldier',
  331: 'Soldier',
  332: 'Soldier',
  333: 'Soldier',
  334: 'Soldier',
  336: 'Soldier',
  337: 'Soldier',
  338: 'Soldier',
  339: 'Soldier',
  340: 'Soldier',
  341: 'Soldier',
  342: 'Soldier',
  343: 'Soldier',
  344: 'Soldier',
  346: 'Soldier',
  347: 'Soldier',
  348: 'Soldier',
  349: 'Soldier',
  351: 'Soldier',
  352: 'Soldier',
  353: 'Soldier',
  354: 'Soldier',
  356: 'Soldier',
  357: 'Soldier',
  358: 'Soldier',
  359: 'Soldier',
  360: 'Soldier',
  361: 'Soldier',
  362: 'Soldier',
  363: 'Soldier',
  364: 'Soldier',
  366: 'Soldier',
  367: 'Soldier',
  368: 'Soldier',
  369: 'Soldier',
  370: 'Soldier',
  371: 'Soldier',
  372: 'Soldier',
  373: 'Soldier',
  374: 'Soldier',
  376: 'Soldier',
  377: 'Soldier',
  378: 'Soldier',
  379: 'Soldier',
  381: 'Soldier',
  382: 'Soldier',
  383: 'Soldier',
  384: 'Soldier',
  386: 'Soldier',
  387: 'Soldier',
  388: 'Soldier',
  389: 'Soldier',
  390: 'Soldier',
  391: 'Soldier',
  392: 'Soldier',
  393: 'Soldier',
  394: 'Soldier',
  396: 'Soldier',
  397: 'Soldier',
  398: 'Soldier',
  399: 'Soldier',
  400: 'Soldier',
  401: 'Soldier',
  402: 'Soldier',
  403: 'Soldier',
  404: 'Soldier',
  406: 'Soldier',
  407: 'Soldier',
  408: 'Soldier',
  409: 'Soldier',
  411: 'Soldier',
  412: 'Soldier',
  413: 'Soldier',
  414: 'Soldier',
  416: 'Soldier',
  417: 'Soldier',
  418: 'Soldier',
  419: 'Soldier',
  420: 'Soldier',
  421: 'Soldier',
  422: 'Soldier',
  423: 'Soldier',
  424: 'Soldier',
  431: 'Soldier',
  432: 'Soldier',
  433: 'Soldier',
  434: 'Soldier',
  435: 'Soldier',
  436: 'Soldier',
  437: 'Soldier',
  438: 'Soldier',
  439: 'Soldier',
  441: 'Soldier',
  442: 'Soldier',
  443: 'Soldier',
  444: 'Soldier',
  445: 'Soldier',
  446: 'Soldier',
  447: 'Soldier',
  448: 'Soldier',
  449: 'Soldier',
  451: 'Soldier',
  452: 'Soldier',
  453: 'Soldier',
  454: 'Soldier',
  455: 'Soldier',
  456: 'Soldier',
  457: 'Soldier',
  458: 'Soldier',
  459: 'Soldier',
  461: 'Soldier',
  462: 'Soldier',
  463: 'Soldier',
  464: 'Soldier',
  465: 'Soldier',
  466: 'Soldier',
  467: 'Soldier',
  468: 'Soldier',
  469: 'Soldier',
  470: 'Soldier',
  471: 'Soldier',
  472: 'Soldier',
  473: 'Soldier',
  474: 'Soldier',
  475: 'Soldier',
  476: 'Soldier',
  477: 'Soldier',
  478: 'Soldier',
  481: 'Soldier',
  482: 'Soldier',
  483: 'Soldier',
  484: 'Soldier',
  485: 'Soldier',
  486: 'Soldier',
  487: 'Soldier',
  488: 'Soldier',
  489: 'Soldier',
  491: 'Soldier',
  492: 'Soldier',
  493: 'Soldier',
  494: 'Soldier',
  495: 'Soldier',
  496: 'Soldier',
  497: 'Soldier',
  498: 'Soldier',
  499: 'Soldier',
  500: 'Soldier',
  501: 'Soldier',
  502: 'Soldier',
  503: 'Soldier',
  504: 'Soldier',
  506: 'Soldier',
  507: 'Soldier',
  508: 'Soldier',
  509: 'Soldier',
  510: 'Soldier',
  511: 'Soldier',
  512: 'Soldier',
  513: 'Soldier',
  514: 'Soldier',
  516: 'Soldier',
  517: 'Soldier',
  518: 'Soldier',
  519: 'Soldier',
  520: 'Soldier',
  521: 'Soldier',
  522: 'Soldier',
  523: 'Soldier',
  524: 'Soldier',
  531: 'Soldier',
  532: 'Soldier',
  533: 'Soldier',
  534: 'Soldier',
  535: 'Soldier',
  536: 'Soldier',
  537: 'Soldier',
  538: 'Soldier',
  539: 'Soldier',
  541: 'Soldier',
  542: 'Soldier',
  543: 'Soldier',
  544: 'Soldier',
  545: 'Soldier',
  546: 'Soldier',
  547: 'Soldier',
  548: 'Soldier',
  549: 'Soldier',
  551: 'Soldier',
  552: 'Soldier',
  553: 'Soldier',
  554: 'Soldier',
  555: 'Soldier',
  556: 'Soldier',
  557: 'Soldier',
  558: 'Soldier',
  559: 'Soldier',
  561: 'Soldier',
  562: 'Soldier',
  563: 'Soldier',
  564: 'Soldier',
  565: 'Soldier',
  566: 'Soldier',
  567: 'Soldier',
  568: 'Soldier',
  569: 'Soldier',
  570: 'Soldier',
  571: 'Soldier',
  572: 'Soldier',
  573: 'Soldier',
  574: 'Soldier',
  575: 'Soldier',
  576: 'Soldier',
  577: 'Soldier',
  578: 'Soldier',
  581: 'Soldier',
  582: 'Soldier',
  583: 'Soldier',
  584: 'Soldier',
  585: 'Soldier',
  586: 'Soldier',
  587: 'Soldier',
  588: 'Soldier',
  589: 'Soldier',
  591: 'Soldier',
  592: 'Soldier',
  593: 'Soldier',
  594: 'Soldier',
  596: 'Soldier',
  597: 'Soldier',
  598: 'Soldier',
  599: 'Soldier',
  601: 'Soldier',
  602: 'Soldier',
  603: 'Soldier',
  604: 'Soldier',
  605: 'Soldier',
  606: 'Soldier',
  607: 'Soldier',
  608: 'Soldier',
  609: 'Soldier',
  611: 'Soldier',
  612: 'Soldier',
  613: 'Soldier',
  614: 'Soldier',
  615: 'Soldier',
  616: 'Soldier',
  617: 'Soldier',
  618: 'Soldier',
  619: 'Soldier',
  620: 'Soldier',
  621: 'Soldier',
  622: 'Soldier',
  623: 'Soldier',
  624: 'Soldier',
  625: 'Soldier',
  626: 'Soldier',
  627: 'Soldier',
  628: 'Soldier',
  631: 'Soldier',
  632: 'Soldier',
  633: 'Soldier',
  634: 'Soldier',
  635: 'Soldier',
  636: 'Soldier',
  637: 'Soldier',
  638: 'Soldier',
  639: 'Soldier',
  641: 'Soldier',
  642: 'Soldier',
  643: 'Soldier',
  644: 'Soldier',
  646: 'Soldier',
  647: 'Soldier',
  648: 'Soldier',
  649: 'Soldier',
  651: 'Soldier',
  652: 'Soldier',
  653: 'Soldier',
  654: 'Soldier',
  655: 'Soldier',
  656: 'Soldier',
  657: 'Soldier',
  658: 'Soldier',
  659: 'Soldier',
  661: 'Soldier',
  662: 'Soldier',
  663: 'Soldier',
  664: 'Soldier',
  665: 'Soldier',
  666: 'Soldier',
  667: 'Soldier',
  668: 'Soldier',
  669: 'Soldier',
  670: 'Soldier',
  671: 'Soldier',
  672: 'Soldier',
  673: 'Soldier',
  674: 'Soldier',
  675: 'Soldier',
  676: 'Soldier',
  677: 'Soldier',
  678: 'Soldier',
  681: 'Soldier',
  682: 'Soldier',
  683: 'Soldier',
  684: 'Soldier',
  685: 'Soldier',
  686: 'Soldier',
  687: 'Soldier',
  688: 'Soldier',
  689: 'Soldier',
  691: 'Soldier',
  692: 'Soldier',
  693: 'Soldier',
  694: 'Soldier',
  696: 'Soldier',
  697: 'Soldier',
  698: 'Soldier',
  699: 'Soldier',
  701: 'Soldier',
  702: 'Soldier',
  703: 'Soldier',
  704: 'Soldier',
  705: 'Soldier',
  706: 'Soldier',
  707: 'Soldier',
  708: 'Soldier',
  709: 'Soldier',
  711: 'Soldier',
  712: 'Soldier',
  713: 'Soldier',
  714: 'Soldier',
  715: 'Soldier',
  716: 'Soldier',
  717: 'Soldier',
  718: 'Soldier',
  719: 'Soldier',
  720: 'Soldier',
  721: 'Soldier',
  722: 'Soldier',
  723: 'Soldier',
  724: 'Soldier',
  725: 'Soldier',
  726: 'Soldier',
  727: 'Soldier',
  728: 'Soldier',
  729: 'Soldier',
  731: 'Soldier',
  732: 'Soldier',
  733: 'Soldier',
  734: 'Soldier',
  735: 'Soldier',
  736: 'Soldier',
  737: 'Soldier',
  738: 'Soldier',
  739: 'Soldier',
  741: 'Soldier',
  742: 'Soldier',
  743: 'Soldier',
  744: 'Soldier',
  745: 'Soldier',
  746: 'Soldier',
  747: 'Soldier',
  748: 'Soldier',
  749: 'Soldier',
  751: 'Soldier',
  752: 'Soldier',
  753: 'Soldier',
  754: 'Soldier',
  755: 'Soldier',
  756: 'Soldier',
  757: 'Soldier',
  758: 'Soldier',
  759: 'Soldier',
  761: 'Soldier',
  762: 'Soldier',
  763: 'Soldier',
  764: 'Soldier',
  765: 'Soldier',
  766: 'Soldier',
  767: 'Soldier',
  768: 'Soldier',
  769: 'Soldier',
  771: 'Soldier',
  772: 'Soldier',
  773: 'Soldier',
  774: 'Soldier',
  775: 'Soldier',
  776: 'Soldier',
  777: 'Soldier',
  778: 'Soldier',
  779: 'Soldier',
  781: 'Soldier',
  782: 'Soldier',
  783: 'Soldier',
  784: 'Soldier',
  785: 'Soldier',
  787: 'Soldier',
  788: 'Soldier',
  789: 'Soldier',
  790: 'Soldier',
  791: 'Soldier',
  801: 'Muse',
  802: 'Muse',
  803: 'Muse',
  804: 'Muse',
  805: 'Muse',
  806: 'Muse',
  807: 'Muse',
  808: 'Muse',
  809: 'Muse',
  810: 'Muse',
  811: 'Muse',
  812: 'Muse',
  813: 'Muse',
  814: 'Muse',
  815: 'Muse',
  816: 'Muse',
  817: 'Muse',
  818: 'Muse',
  821: 'Muse',
  822: 'Muse',
  823: 'Muse',
  824: 'Muse',
  825: 'Muse',
  826: 'Muse',
  827: 'Muse',
  828: 'Muse',
  829: 'Muse',
  831: 'Muse',
  832: 'Muse',
  833: 'Muse',
  834: 'Muse',
  835: 'Muse',
  836: 'Muse',
  837: 'Muse',
  838: 'Muse',
  839: 'Muse',
  841: 'Muse',
  842: 'Muse',
  843: 'Muse',
  844: 'Muse',
  846: 'Muse',
  847: 'Muse',
  848: 'Muse',
  849: 'Muse',
  851: 'Muse',
  852: 'Muse',
  853: 'Muse',
  854: 'Muse',
  855: 'Muse',
  856: 'Muse',
  857: 'Muse',
  858: 'Muse',
  859: 'Muse',
  861: 'Muse',
  862: 'Muse',
  863: 'Muse',
  864: 'Muse',
  865: 'Muse',
  866: 'Muse',
  867: 'Muse',
  868: 'Muse',
  869: 'Muse',
  871: 'Muse',
  872: 'Muse',
  873: 'Muse',
  874: 'Muse',
  876: 'Muse',
  877: 'Muse',
  878: 'Muse',
  879: 'Muse',
  881: 'Muse',
  882: 'Muse',
  883: 'Muse',
  884: 'Muse',
  886: 'Muse',
  887: 'Muse',
  888: 'Muse',
  889: 'Muse',
  891: 'Muse',
  892: 'Muse',
  893: 'Muse',
  894: 'Muse',
  895: 'Muse',
  896: 'Muse',
  897: 'Muse',
  898: 'Muse',
  899: 'Muse',
  901: 'Muse',
  902: 'Muse',
  903: 'Muse',
  904: 'Muse',
  905: 'Muse',
  906: 'Muse',
  907: 'Muse',
  908: 'Muse',
  909: 'Muse',
  911: 'Muse',
  912: 'Muse',
  913: 'Muse',
  914: 'Muse',
  915: 'Muse',
  916: 'Muse',
  917: 'Muse',
  918: 'Muse',
  919: 'Muse',
  921: 'Muse',
  922: 'Muse',
  923: 'Muse',
  924: 'Muse',
  925: 'Muse',
  926: 'Muse',
  927: 'Muse',
  928: 'Muse',
  929: 'Muse',
  930: 'Muse',
  931: 'Muse',
  932: 'Muse',
  933: 'Muse',
  934: 'Muse',
  935: 'Muse',
  936: 'Muse',
  937: 'Muse',
  938: 'Muse',
  939: 'Muse',
  940: 'Muse',
  941: 'Muse',
  942: 'Muse',
  943: 'Muse',
  944: 'Muse',
  945: 'Muse',
  946: 'Muse',
  947: 'Muse',
  948: 'Muse',
  951: 'Muse',
  952: 'Muse',
  953: 'Muse',
  954: 'Muse',
  955: 'Muse',
  956: 'Muse',
  957: 'Muse',
  958: 'Muse',
  959: 'Muse',
  961: 'Muse',
  962: 'Muse',
  963: 'Muse',
  964: 'Muse',
  965: 'Muse',
  966: 'Muse',
  967: 'Muse',
  968: 'Muse',
  969: 'Muse',
  971: 'Muse',
  972: 'Muse',
  973: 'Muse',
  974: 'Muse',
  975: 'Muse',
  976: 'Muse',
  977: 'Muse',
  978: 'Muse',
  979: 'Muse',
  980: 'Muse',
  981: 'Muse',
  982: 'Muse',
  983: 'Muse',
  984: 'Muse',
  985: 'Muse',
  986: 'Muse',
  987: 'Muse',
  988: 'Muse',
  989: 'Muse',
  990: 'Muse',
  991: 'Muse',
  992: 'Muse',
  993: 'Muse',
  994: 'Muse',
  996: 'Muse',
  997: 'Muse',
  998: 'Muse',
  999: 'Muse',
  1000: 'Muse',
  1001: 'Muse',
  1002: 'Muse',
  1003: 'Muse',
  1004: 'Muse',
  1006: 'Muse',
  1007: 'Muse',
  1008: 'Muse',
  1009: 'Muse',
  1011: 'Muse',
  1012: 'Muse',
  1013: 'Muse',
  1014: 'Muse',
  1015: 'Muse',
  1016: 'Muse',
  1017: 'Muse',
  1018: 'Muse',
  1019: 'Muse',
  1021: 'Muse',
  1022: 'Muse',
  1023: 'Muse',
  1024: 'Muse',
  1025: 'Muse',
  1026: 'Muse',
  1027: 'Muse',
  1028: 'Muse',
  1029: 'Muse',
  1031: 'Muse',
  1032: 'Muse',
  1033: 'Muse',
  1034: 'Muse',
  1035: 'Muse',
  1036: 'Muse',
  1037: 'Muse',
  1038: 'Muse',
  1039: 'Muse',
  1041: 'Muse',
  1042: 'Muse',
  1043: 'Muse',
  1044: 'Muse',
  1045: 'Muse',
  1051: 'Muse',
  1052: 'Muse',
  1053: 'Muse',
  1054: 'Muse',
  1055: 'Muse',
  1056: 'Muse',
  1057: 'Muse',
  1058: 'Muse',
  1059: 'Muse',
  1060: 'Muse',
  1061: 'Muse',
  1062: 'Muse',
  1063: 'Muse',
  1064: 'Muse',
  1065: 'Muse',
  1066: 'Muse',
  1067: 'Muse',
  1068: 'Muse',
  1071: 'Muse',
  1072: 'Muse',
  1073: 'Muse',
  1074: 'Muse',
  1075: 'Muse',
  1076: 'Muse',
  1077: 'Muse',
  1078: 'Muse',
  1079: 'Muse',
  1081: 'Muse',
  1082: 'Muse',
  1083: 'Muse',
  1084: 'Muse',
  1086: 'Muse',
  1087: 'Muse',
  1088: 'Muse',
  1089: 'Muse',
  1090: 'Muse',
  1091: 'Muse',
  1092: 'Muse',
  1093: 'Muse',
  1094: 'Muse',
  1096: 'Muse',
  1097: 'Muse',
  1098: 'Muse',
  1099: 'Muse',
  1100: 'Muse',
  1101: 'Muse',
  1102: 'Muse',
  1103: 'Muse',
  1104: 'Muse',
  1105: 'Muse',
  1106: 'Muse',
  1107: 'Muse',
  1108: 'Muse',
  1109: 'Muse',
  1110: 'Muse',
  1111: 'Muse',
  1112: 'Muse',
  1113: 'Muse',
  1114: 'Muse',
  1115: 'Muse',
  1116: 'Muse',
  1117: 'Muse',
  1118: 'Muse',
  1119: 'Muse',
  1120: 'Muse',
  1121: 'Muse',
  1122: 'Muse',
  1123: 'Muse',
  1124: 'Muse',
  1125: 'Muse',
  1126: 'Muse',
  1127: 'Muse',
  1128: 'Muse',
  1129: 'Muse',
  1130: 'Muse',
  1131: 'Muse',
  1132: 'Muse',
  1133: 'Muse',
  1134: 'Muse',
  1135: 'Muse',
  1136: 'Muse',
  1137: 'Muse',
  1138: 'Muse',
  1139: 'Muse',
  1141: 'Muse',
  1142: 'Muse',
  1143: 'Muse',
  1144: 'Muse',
  1145: 'Muse',
  1146: 'Muse',
  1147: 'Muse',
  1148: 'Muse',
  1149: 'Muse',
  1151: 'Muse',
  1152: 'Muse',
  1153: 'Muse',
  1154: 'Muse',
  1155: 'Muse',
  1156: 'Muse',
  1157: 'Muse',
  1158: 'Muse',
  1159: 'Muse',
  1161: 'Muse',
  1162: 'Muse',
  1163: 'Muse',
  1164: 'Muse',
  1165: 'Muse',
  1166: 'Muse',
  1167: 'Muse',
  1168: 'Muse',
  1169: 'Muse',
  1171: 'Muse',
  1172: 'Muse',
  1173: 'Muse',
  1174: 'Muse',
  1175: 'Muse',
  1176: 'Muse',
  1177: 'Muse',
  1178: 'Muse',
  1179: 'Muse',
  1180: 'Muse',
  1186: 'Muse',
  1187: 'Muse',
  1188: 'Muse',
  1189: 'Muse',
  1190: 'Muse',
  1191: 'Muse',
  1192: 'Muse',
  1193: 'Muse',
  1194: 'Muse',
  1195: 'Muse',
  1196: 'Muse',
  1197: 'Muse',
  1198: 'Muse',
  1199: 'Muse',
  1200: 'Muse',
  1201: 'Muse',
  1202: 'Muse',
  1203: 'Muse',
  1206: 'Muse',
  1207: 'Muse',
  1208: 'Muse',
  1209: 'Muse',
  1211: 'Muse',
  1212: 'Muse',
  1213: 'Muse',
  1214: 'Muse',
  1215: 'Muse',
  1216: 'Muse',
  1217: 'Muse',
  1218: 'Muse',
  1219: 'Muse',
  1221: 'Muse',
  1222: 'Muse',
  1223: 'Muse',
  1224: 'Muse',
  1225: 'Muse',
  1226: 'Muse',
  1227: 'Muse',
  1228: 'Muse',
  1229: 'Muse',
  1230: 'Muse',
  1231: 'Muse',
  1232: 'Muse',
  1233: 'Muse',
  1234: 'Muse',
  1236: 'Muse',
  1237: 'Muse',
  1238: 'Muse',
  1239: 'Muse',
  1240: 'Muse',
  1241: 'Muse',
  1242: 'Muse',
  1243: 'Muse',
  1244: 'Muse',
  1245: 'Muse',
  1246: 'Muse',
  1247: 'Muse',
  1248: 'Muse',
  1249: 'Muse',
  1250: 'Muse',
  1251: 'Muse',
  1252: 'Muse',
  1253: 'Muse',
  1254: 'Muse',
  1256: 'Muse',
  1257: 'Muse',
  1258: 'Muse',
  1261: 'Muse',
  1262: 'Muse',
  1263: 'Muse',
  1266: 'Muse',
  1267: 'Muse',
  1268: 'Muse',
  1269: 'Muse',
  1270: 'Muse',
  1271: 'Muse',
  1272: 'Muse',
  1273: 'Muse',
  1274: 'Muse',
  1275: 'Muse',
  1276: 'Muse',
  1277: 'Muse',
  1278: 'Muse',
  1279: 'Muse',
  1280: 'Muse',
  1281: 'Muse',
  1282: 'Muse',
  1283: 'Muse',
  1284: 'Muse',
  1286: 'Muse',
  1287: 'Muse',
  1288: 'Muse',
  1289: 'Muse',
  1290: 'Muse',
  1291: 'Muse',
  1292: 'Muse',
  1293: 'Muse',
  1294: 'Muse',
  1296: 'Muse',
  1297: 'Muse',
  1298: 'Muse',
  1299: 'Muse',
  1300: 'Muse',
  1301: 'Muse',
  1302: 'Muse',
  1303: 'Muse',
  1304: 'Muse',
  1306: 'Muse',
  1307: 'Muse',
  1308: 'Muse',
  1309: 'Muse',
  1310: 'Muse',
  1311: 'Muse',
  1312: 'Muse',
  1313: 'Muse',
  1314: 'Muse',
  1316: 'Muse',
  1317: 'Muse',
  1318: 'Muse',
  1319: 'Muse',
  1320: 'Muse',
  1321: 'Muse',
  1322: 'Muse',
  1323: 'Muse',
  1324: 'Muse',
  1401: 'Hawker',
  1402: 'Hawker',
  1403: 'Hawker',
  1404: 'Hawker',
  1405: 'Hawker',
  1406: 'Hawker',
  1407: 'Hawker',
  1408: 'Hawker',
  1409: 'Hawker',
  1411: 'Hawker',
  1412: 'Hawker',
  1413: 'Hawker',
  1414: 'Hawker',
  1415: 'Hawker',
  1416: 'Hawker',
  1417: 'Hawker',
  1418: 'Hawker',
  1419: 'Hawker',
  1420: 'Hawker',
  1421: 'Hawker',
  1422: 'Hawker',
  1423: 'Hawker',
  1424: 'Hawker',
  1425: 'Hawker',
  1426: 'Hawker',
  1427: 'Hawker',
  1428: 'Hawker',
  1431: 'Hawker',
  1432: 'Hawker',
  1433: 'Hawker',
  1434: 'Hawker',
  1435: 'Hawker',
  1436: 'Hawker',
  1437: 'Hawker',
  1438: 'Hawker',
  1439: 'Hawker',
  1441: 'Hawker',
  1442: 'Hawker',
  1443: 'Hawker',
  1444: 'Hawker',
  1445: 'Hawker',
  1446: 'Hawker',
  1447: 'Hawker',
  1448: 'Hawker',
  1449: 'Hawker',
  1451: 'Hawker',
  1452: 'Hawker',
  1453: 'Hawker',
  1454: 'Hawker',
  1455: 'Hawker',
  1456: 'Hawker',
  1457: 'Hawker',
  1458: 'Hawker',
  1459: 'Hawker',
  1461: 'Hawker',
  1462: 'Hawker',
  1463: 'Hawker',
  1464: 'Hawker',
  1465: 'Hawker',
  1466: 'Hawker',
  1467: 'Hawker',
  1468: 'Hawker',
  1469: 'Hawker',
  1471: 'Hawker',
  1472: 'Hawker',
  1473: 'Hawker',
  1474: 'Hawker',
  1475: 'Hawker',
  1476: 'Hawker',
  1477: 'Hawker',
  1478: 'Hawker',
  1479: 'Hawker',
  1480: 'Hawker',
  1481: 'Hawker',
  1482: 'Hawker',
  1483: 'Hawker',
  1484: 'Hawker',
  1486: 'Hawker',
  1487: 'Hawker',
  1488: 'Hawker',
  1489: 'Hawker',
  1490: 'Hawker',
  1491: 'Hawker',
  1492: 'Hawker',
  1493: 'Hawker',
  1494: 'Hawker',
  1496: 'Hawker',
  1497: 'Hawker',
  1498: 'Hawker',
  1499: 'Hawker',
  1500: 'Hawker',
  1501: 'Hawker',
  1502: 'Hawker',
  1503: 'Hawker',
  1504: 'Hawker',
  1506: 'Hawker',
  1507: 'Hawker',
  1508: 'Hawker',
  1509: 'Hawker',
  1510: 'Hawker',
  1511: 'Hawker',
  1512: 'Hawker',
  1513: 'Hawker',
  1514: 'Hawker',
  1515: 'Hawker',
  1516: 'Hawker',
  1517: 'Hawker',
  1518: 'Hawker',
  1519: 'Hawker',
  1521: 'Hawker',
  1522: 'Hawker',
  1523: 'Hawker',
  1524: 'Hawker',
  1525: 'Hawker',
  1526: 'Hawker',
  1527: 'Hawker',
  1528: 'Hawker',
  1529: 'Hawker',
  1530: 'Hawker',
  1531: 'Hawker',
  1532: 'Hawker',
  1533: 'Hawker',
  1534: 'Hawker',
  1535: 'Hawker',
  1536: 'Hawker',
  1537: 'Hawker',
  1538: 'Hawker',
  1541: 'Hawker',
  1542: 'Hawker',
  1543: 'Hawker',
  1544: 'Hawker',
  1545: 'Hawker',
  1546: 'Hawker',
  1547: 'Hawker',
  1548: 'Hawker',
  1549: 'Hawker',
  1551: 'Hawker',
  1552: 'Hawker',
  1553: 'Hawker',
  1554: 'Hawker',
  1555: 'Hawker',
  1556: 'Hawker',
  1557: 'Hawker',
  1558: 'Hawker',
  1559: 'Hawker',
  1561: 'Hawker',
  1562: 'Hawker',
  1563: 'Hawker',
  1564: 'Hawker',
  1565: 'Hawker',
  1566: 'Hawker',
  1567: 'Hawker',
  1568: 'Hawker',
  1569: 'Hawker',
  1571: 'Hawker',
  1572: 'Hawker',
  1573: 'Hawker',
  1574: 'Hawker',
  1575: 'Hawker',
  1576: 'Hawker',
  1577: 'Hawker',
  1578: 'Hawker',
  1579: 'Hawker',
  1581: 'Hawker',
  1582: 'Hawker',
  1583: 'Hawker',
  1584: 'Hawker',
  1585: 'Hawker',
  1586: 'Hawker',
  1587: 'Hawker',
  1588: 'Hawker',
  1589: 'Hawker',
  1591: 'Hawker',
  1592: 'Hawker',
  1593: 'Hawker',
  1594: 'Hawker',
  1595: 'Hawker',
  1596: 'Hawker',
  1597: 'Hawker',
  1598: 'Hawker',
  1599: 'Hawker',
  1601: 'Hawker',
  1602: 'Hawker',
  1603: 'Hawker',
  1604: 'Hawker',
  1605: 'Hawker',
  1606: 'Hawker',
  1607: 'Hawker',
  1608: 'Hawker',
  1609: 'Hawker',
  1610: 'Hawker',
  1611: 'Hawker',
  1612: 'Hawker',
  1613: 'Hawker',
  1614: 'Hawker',
  1616: 'Hawker',
  1617: 'Hawker',
  1618: 'Hawker',
  1619: 'Hawker',
  1620: 'Hawker',
  1621: 'Hawker',
  1622: 'Hawker',
  1623: 'Hawker',
  1624: 'Hawker',
  1626: 'Hawker',
  1627: 'Hawker',
  1628: 'Hawker',
  1629: 'Hawker',
  1631: 'Hawker',
  1632: 'Hawker',
  1633: 'Hawker',
  1634: 'Hawker',
  1636: 'Hawker',
  1637: 'Hawker',
  1638: 'Hawker',
  1639: 'Hawker',
  1641: 'Hawker',
  1642: 'Hawker',
  1643: 'Hawker',
  1644: 'Hawker',
  1646: 'Hawker',
  1647: 'Hawker',
  1648: 'Hawker',
  1649: 'Hawker',
  1651: 'Hawker',
  1652: 'Hawker',
  1653: 'Hawker',
  1654: 'Hawker',
  1656: 'Hawker',
  1661: 'Hawker',
  1662: 'Hawker',
  1663: 'Hawker',
  1664: 'Hawker',
  1665: 'Hawker',
  1666: 'Hawker',
  1667: 'Hawker',
  1668: 'Hawker',
  1669: 'Hawker',
  1670: 'Hawker',
  1671: 'Hawker',
  1672: 'Hawker',
  1673: 'Hawker',
  1674: 'Hawker',
  1675: 'Hawker',
  1676: 'Hawker',
  1677: 'Hawker',
  1678: 'Hawker',
  1681: 'Hawker',
  1682: 'Hawker',
  1683: 'Hawker',
  1684: 'Hawker',
  1685: 'Hawker',
  1686: 'Hawker',
  1687: 'Hawker',
  1688: 'Hawker',
  1689: 'Hawker',
  1691: 'Hawker',
  1692: 'Hawker',
  1693: 'Hawker',
  1694: 'Hawker',
  1695: 'Hawker',
  1696: 'Hawker',
  1697: 'Hawker',
  1698: 'Hawker',
  1699: 'Hawker',
  1701: 'Hawker',
  1702: 'Hawker',
  1703: 'Hawker',
  1704: 'Hawker',
  1705: 'Hawker',
  1706: 'Hawker',
  1707: 'Hawker',
  1708: 'Hawker',
  1709: 'Hawker',
  1711: 'Hawker',
  1712: 'Hawker',
  1713: 'Hawker',
  1714: 'Hawker',
  1715: 'Hawker',
  1716: 'Hawker',
  1717: 'Hawker',
  1718: 'Hawker',
  1719: 'Hawker',
  1720: 'Hawker',
  1721: 'Hawker',
  1722: 'Hawker',
  1723: 'Hawker',
  1724: 'Hawker',
  1725: 'Hawker',
  1726: 'Hawker',
  1727: 'Hawker',
  1728: 'Hawker',
  1729: 'Hawker',
  1731: 'Hawker',
  1732: 'Hawker',
  1733: 'Hawker',
  1734: 'Hawker',
  1735: 'Hawker',
  1736: 'Hawker',
  1737: 'Hawker',
  1738: 'Hawker',
  1739: 'Hawker',
  1740: 'Hawker',
  1741: 'Hawker',
  1742: 'Hawker',
  1743: 'Hawker',
  1744: 'Hawker',
  1746: 'Hawker',
  1747: 'Hawker',
  1748: 'Hawker',
  1749: 'Hawker',
  1750: 'Hawker',
  1751: 'Hawker',
  1752: 'Hawker',
  1753: 'Hawker',
  1754: 'Hawker',
  1756: 'Hawker',
  1757: 'Hawker',
  1758: 'Hawker',
  1759: 'Hawker',
  1760: 'Hawker',
  1761: 'Hawker',
  1762: 'Hawker',
  1763: 'Hawker',
  1764: 'Hawker',
  1765: 'Hawker',
  1766: 'Hawker',
  1767: 'Hawker',
  1768: 'Hawker',
  1769: 'Hawker',
  1770: 'Hawker',
  1771: 'Hawker',
  1772: 'Hawker',
  1773: 'Hawker',
  1774: 'Hawker',
  1781: 'Hawker',
  1782: 'Hawker',
  1783: 'Hawker',
  1784: 'Hawker',
  1785: 'Hawker',
  1786: 'Hawker',
  1787: 'Hawker',
  1788: 'Hawker',
  1789: 'Hawker',
  1790: 'Hawker',
  1791: 'Hawker',
  1792: 'Hawker',
  1793: 'Hawker',
  1794: 'Hawker',
  1795: 'Hawker',
  1796: 'Hawker',
  1797: 'Hawker',
  1798: 'Hawker',
  1801: 'Hawker',
  1802: 'Hawker',
  1803: 'Hawker',
  1804: 'Hawker',
  1805: 'Hawker',
  1806: 'Hawker',
  1807: 'Hawker',
  1808: 'Hawker',
  1809: 'Hawker',
  1811: 'Hawker',
  1812: 'Hawker',
  1813: 'Hawker',
  1814: 'Hawker',
  1816: 'Hawker',
  1817: 'Hawker',
  1818: 'Hawker',
  1819: 'Hawker',
  1820: 'Hawker',
  1821: 'Hawker',
  1822: 'Hawker',
  1823: 'Hawker',
  1824: 'Hawker',
  1826: 'Hawker',
  1827: 'Hawker',
  1828: 'Hawker',
  1829: 'Hawker',
  1830: 'Hawker',
  1831: 'Hawker',
  1832: 'Hawker',
  1833: 'Hawker',
  1834: 'Hawker',
  1836: 'Hawker',
  1837: 'Hawker',
  1838: 'Hawker',
  1839: 'Hawker',
  1841: 'Hawker',
  1842: 'Hawker',
  1843: 'Hawker',
  1844: 'Hawker',
  1845: 'Hawker',
  1846: 'Hawker',
  1847: 'Hawker',
  1848: 'Hawker',
  1849: 'Hawker',
  1851: 'Hawker',
  1852: 'Hawker',
  1853: 'Hawker',
  1854: 'Hawker',
  1856: 'Hawker',
  1857: 'Hawker',
  1858: 'Hawker',
  1859: 'Hawker',
  1861: 'Hawker',
  1862: 'Hawker',
  1863: 'Hawker',
  1864: 'Hawker',
  1865: 'Hawker',
  1866: 'Hawker',
  1867: 'Hawker',
  1868: 'Hawker',
  1869: 'Hawker',
  1871: 'Hawker',
  1872: 'Hawker',
  1873: 'Hawker',
  1874: 'Hawker',
  1876: 'Hawker',
  1877: 'Hawker',
  1878: 'Hawker',
  1879: 'Hawker',
  1881: 'Hawker',
  1882: 'Hawker',
  1883: 'Hawker',
  1884: 'Hawker',
  1886: 'Hawker',
  1887: 'Hawker',
  1888: 'Hawker',
  1889: 'Hawker',
  1891: 'Hawker',
  1892: 'Hawker',
  1893: 'Hawker',
  1894: 'Hawker',
  1896: 'Hawker',
  1897: 'Hawker',
  1898: 'Hawker',
  1899: 'Hawker',
  1900: 'Hawker',
  1901: 'Hawker',
  1902: 'Hawker',
  1903: 'Hawker',
  1904: 'Hawker',
  1906: 'Hawker',
  1907: 'Hawker',
  1908: 'Hawker',
  1909: 'Hawker',
  1910: 'Hawker',
  1911: 'Hawker',
  1912: 'Hawker',
  1913: 'Hawker',
  1914: 'Hawker',
  1916: 'Hawker',
  1917: 'Hawker',
  1918: 'Hawker',
  1919: 'Hawker',
  1920: 'Hawker',
  1921: 'Hawker',
  1922: 'Hawker',
  1923: 'Hawker',
  1924: 'Hawker',
  1926: 'Hawker',
  1927: 'Hawker',
  1928: 'Hawker',
  1929: 'Hawker',
  1930: 'Hawker',
  1931: 'Hawker',
  1932: 'Hawker',
  1933: 'Hawker',
  1934: 'Hawker',
  1936: 'Hawker',
  1937: 'Hawker',
  1938: 'Hawker',
  1939: 'Hawker',
  1940: 'Hawker',
  1941: 'Hawker',
  1942: 'Hawker',
  1943: 'Hawker',
  1944: 'Hawker',
  1946: 'Hawker',
  1947: 'Hawker',
  1948: 'Hawker',
  1949: 'Hawker',
  1951: 'Hawker',
  1952: 'Hawker',
  1953: 'Hawker',
  1954: 'Hawker',
  1956: 'Hawker',
  1957: 'Hawker',
  1958: 'Hawker',
  1959: 'Hawker',
  1960: 'Hawker',
  1961: 'Hawker',
  1966: 'Hawker',
  1967: 'Hawker',
  1968: 'Hawker',
  1969: 'Hawker',
  1970: 'Hawker',
  1971: 'Hawker',
  1976: 'Hawker',
  1977: 'Hawker',
  1978: 'Hawker',
  1979: 'Hawker',
  1980: 'Hawker',
  1981: 'Hawker',
  1982: 'Hawker',
  1983: 'Hawker',
  1984: 'Hawker',
  2001: 'Dealer',
  2002: 'Dealer',
  2003: 'Dealer',
  2004: 'Dealer',
  2005: 'Dealer',
  2006: 'Dealer',
  2007: 'Dealer',
  2008: 'Dealer',
  2009: 'Dealer',
  2011: 'Dealer',
  2012: 'Dealer',
  2013: 'Dealer',
  2014: 'Dealer',
  2015: 'Dealer',
  2016: 'Dealer',
  2017: 'Dealer',
  2018: 'Dealer',
  2019: 'Dealer',
  2020: 'Dealer',
  2021: 'Dealer',
  2022: 'Dealer',
  2023: 'Dealer',
  2024: 'Dealer',
  2025: 'Dealer',
  2026: 'Dealer',
  2027: 'Dealer',
  2028: 'Dealer',
  2031: 'Dealer',
  2032: 'Dealer',
  2033: 'Dealer',
  2034: 'Dealer',
  2035: 'Dealer',
  2036: 'Dealer',
  2037: 'Dealer',
  2038: 'Dealer',
  2039: 'Dealer',
  2040: 'Dealer',
  2041: 'Dealer',
  2042: 'Dealer',
  2043: 'Dealer',
  2044: 'Dealer',
  2046: 'Dealer',
  2047: 'Dealer',
  2048: 'Dealer',
  2049: 'Dealer',
  2050: 'Dealer',
  2051: 'Dealer',
  2052: 'Dealer',
  2053: 'Dealer',
  2054: 'Dealer',
  2055: 'Dealer',
  2056: 'Dealer',
  2057: 'Dealer',
  2058: 'Dealer',
  2059: 'Dealer',
  2060: 'Dealer',
  2061: 'Dealer',
  2062: 'Dealer',
  2063: 'Dealer',
  2064: 'Dealer',
  2065: 'Dealer',
  2066: 'Dealer',
  2067: 'Dealer',
  2068: 'Dealer',
  2069: 'Dealer',
  2071: 'Dealer',
  2072: 'Dealer',
  2073: 'Dealer',
  2074: 'Dealer',
  2075: 'Dealer',
  2076: 'Dealer',
  2077: 'Dealer',
  2078: 'Dealer',
  2079: 'Dealer',
  2080: 'Dealer',
  2081: 'Dealer',
  2082: 'Dealer',
  2083: 'Dealer',
  2084: 'Dealer',
  2086: 'Dealer',
  2087: 'Dealer',
  2088: 'Dealer',
  2089: 'Dealer',
  2090: 'Dealer',
  2091: 'Dealer',
  2092: 'Dealer',
  2093: 'Dealer',
  2094: 'Dealer',
  2095: 'Dealer',
  2096: 'Dealer',
  2097: 'Dealer',
  2098: 'Dealer',
  2099: 'Dealer',
  2101: 'Dealer',
  2102: 'Dealer',
  2103: 'Dealer',
  2104: 'Dealer',
  2105: 'Dealer',
  2106: 'Dealer',
  2107: 'Dealer',
  2108: 'Dealer',
  2109: 'Dealer',
  2110: 'Dealer',
  2111: 'Dealer',
  2112: 'Dealer',
  2113: 'Dealer',
  2114: 'Dealer',
  2115: 'Dealer',
  2116: 'Dealer',
  2117: 'Dealer',
  2118: 'Dealer',
  2119: 'Dealer',
  2120: 'Dealer',
  2121: 'Dealer',
  2122: 'Dealer',
  2123: 'Dealer',
  2124: 'Dealer',
  2126: 'Dealer',
  2127: 'Dealer',
  2128: 'Dealer',
  2129: 'Dealer',
  2130: 'Dealer',
  2131: 'Dealer',
  2132: 'Dealer',
  2133: 'Dealer',
  2134: 'Dealer',
  2136: 'Dealer',
  2137: 'Dealer',
  2138: 'Dealer',
  2139: 'Dealer',
  2140: 'Dealer',
  2141: 'Dealer',
  2142: 'Dealer',
  2143: 'Dealer',
  2144: 'Dealer',
  2146: 'Dealer',
  2147: 'Dealer',
  2148: 'Dealer',
  2149: 'Dealer',
  2150: 'Dealer',
  2151: 'Dealer',
  2152: 'Dealer',
  2153: 'Dealer',
  2154: 'Dealer',
  2156: 'Dealer',
  2157: 'Dealer',
  2158: 'Dealer',
  2159: 'Dealer',
  2160: 'Dealer',
  2161: 'Dealer',
  2162: 'Dealer',
  2163: 'Dealer',
  2164: 'Dealer',
  2166: 'Dealer',
  2176: 'Dealer',
  2186: 'Dealer',
  2196: 'Dealer',
  2206: 'Dealer',
  2207: 'Dealer',
  2208: 'Dealer',
  2209: 'Dealer',
  2210: 'Dealer',
  2211: 'Dealer',
  2212: 'Dealer',
  2213: 'Dealer',
  2214: 'Dealer',
  2216: 'Dealer',
  2226: 'Dealer',
  2236: 'Dealer',
  2237: 'Dealer',
  2238: 'Dealer',
  2239: 'Dealer',
  2240: 'Dealer',
  2241: 'Dealer',
  2242: 'Dealer',
  2243: 'Dealer',
  2244: 'Dealer',
  2246: 'Dealer',
  2247: 'Dealer',
  2248: 'Dealer',
  2249: 'Dealer',
  2250: 'Dealer',
  2251: 'Dealer',
  2252: 'Dealer',
  2253: 'Dealer',
  2254: 'Dealer',
  2256: 'Dealer',
  2257: 'Dealer',
  2258: 'Dealer',
  2259: 'Dealer',
  2260: 'Dealer',
  2261: 'Dealer',
  2262: 'Dealer',
  2263: 'Dealer',
  2264: 'Dealer',
  2266: 'Dealer',
  2267: 'Dealer',
  2268: 'Dealer',
  2269: 'Dealer',
  2270: 'Dealer',
  2271: 'Dealer',
  2272: 'Dealer',
  2273: 'Dealer',
  2274: 'Dealer',
  2275: 'Dealer',
  2276: 'Dealer',
  2277: 'Dealer',
  2278: 'Dealer',
  2279: 'Dealer',
  2280: 'Dealer',
  2281: 'Dealer',
  2282: 'Dealer',
  2283: 'Dealer',
  2286: 'Dealer',
  2287: 'Dealer',
  2288: 'Dealer',
  2289: 'Dealer',
  2290: 'Dealer',
  2291: 'Dealer',
  2292: 'Dealer',
  2293: 'Dealer',
  2294: 'Dealer',
  2296: 'Dealer',
  2297: 'Dealer',
  2298: 'Dealer',
  2299: 'Dealer',
  2300: 'Dealer',
  2301: 'Dealer',
  2302: 'Dealer',
  2303: 'Dealer',
  2304: 'Dealer',
  2305: 'Dealer',
  2306: 'Dealer',
  2307: 'Dealer',
  2308: 'Dealer',
  2309: 'Dealer',
  2310: 'Dealer',
  2311: 'Dealer',
  2312: 'Dealer',
  2313: 'Dealer',
  2314: 'Dealer',
  2316: 'Dealer',
  2317: 'Dealer',
  2318: 'Dealer',
  2319: 'Dealer',
  2320: 'Dealer',
  2321: 'Dealer',
  2322: 'Dealer',
  2323: 'Dealer',
  2324: 'Dealer',
  2326: 'Dealer',
  2327: 'Dealer',
  2328: 'Dealer',
  2329: 'Dealer',
  2330: 'Dealer',
  2331: 'Dealer',
  2332: 'Dealer',
  2333: 'Dealer',
  2334: 'Dealer',
  2336: 'Dealer',
  2337: 'Dealer',
  2338: 'Dealer',
  2339: 'Dealer',
  2340: 'Dealer',
  2341: 'Dealer',
  2342: 'Dealer',
  2343: 'Dealer',
  2344: 'Dealer',
  2346: 'Dealer',
  2347: 'Dealer',
  2348: 'Dealer',
  2349: 'Dealer',
  2350: 'Dealer',
  2351: 'Dealer',
  2352: 'Dealer',
  2353: 'Dealer',
  2354: 'Dealer',
  2355: 'Dealer',
  2356: 'Dealer',
  2357: 'Dealer',
  2358: 'Dealer',
  2359: 'Dealer',
  2360: 'Dealer',
  2361: 'Dealer',
  2362: 'Dealer',
  2363: 'Dealer',
  2364: 'Dealer',
  2366: 'Dealer',
  2367: 'Dealer',
  2368: 'Dealer',
  2369: 'Dealer',
  2370: 'Dealer',
  2371: 'Dealer',
  2372: 'Dealer',
  2373: 'Dealer',
  2374: 'Dealer',
  2375: 'Dealer',
  2376: 'Dealer',
  2377: 'Dealer',
  2378: 'Dealer',
  2379: 'Dealer',
  2380: 'Dealer',
  2381: 'Dealer',
  2382: 'Dealer',
  2383: 'Dealer',
  2384: 'Dealer',
  2385: 'Dealer',
  2386: 'Dealer',
  2387: 'Dealer',
  2388: 'Dealer',
  2389: 'Dealer',
  2391: 'Dealer',
  2392: 'Dealer',
  2393: 'Dealer',
  2394: 'Dealer',
  2395: 'Dealer',
  2396: 'Dealer',
  2397: 'Dealer',
  2398: 'Dealer',
  2399: 'Dealer',
  2401: 'Dealer',
  2402: 'Dealer',
  2403: 'Dealer',
  2404: 'Dealer',
  2405: 'Dealer',
  2406: 'Dealer',
  2407: 'Dealer',
  2408: 'Dealer',
  2409: 'Dealer',
  2410: 'Dealer',
  2411: 'Dealer',
  2412: 'Dealer',
  2413: 'Dealer',
  2414: 'Dealer',
  2416: 'Dealer',
  2417: 'Dealer',
  2418: 'Dealer',
  2419: 'Dealer',
  2420: 'Dealer',
  2421: 'Dealer',
  2422: 'Dealer',
  2423: 'Dealer',
  2424: 'Dealer',
  2426: 'Dealer',
  2427: 'Dealer',
  2428: 'Dealer',
  2429: 'Dealer',
  2430: 'Dealer',
  2431: 'Dealer',
  2432: 'Dealer',
  2433: 'Dealer',
  2434: 'Dealer',
  2435: 'Dealer',
  2441: 'Dealer',
  2442: 'Dealer',
  2443: 'Dealer',
  2444: 'Dealer',
  2445: 'Dealer',
  2446: 'Dealer',
  2447: 'Dealer',
  2448: 'Dealer',
  2449: 'Dealer',
  2450: 'Dealer',
  2451: 'Dealer',
  2452: 'Dealer',
  2453: 'Dealer',
  2454: 'Dealer',
  2455: 'Dealer',
  2456: 'Dealer',
  2457: 'Dealer',
  2458: 'Dealer',
  2461: 'Dealer',
  2462: 'Dealer',
  2463: 'Dealer',
  2464: 'Dealer',
  2465: 'Dealer',
  2466: 'Dealer',
  2467: 'Dealer',
  2468: 'Dealer',
  2469: 'Dealer',
  2470: 'Dealer',
  2471: 'Dealer',
  2472: 'Dealer',
  2473: 'Dealer',
  2474: 'Dealer',
  2476: 'Dealer',
  2477: 'Dealer',
  2478: 'Dealer',
  2479: 'Dealer',
  2480: 'Dealer',
  2481: 'Dealer',
  2482: 'Dealer',
  2483: 'Dealer',
  2484: 'Dealer',
  2485: 'Dealer',
  2486: 'Dealer',
  2487: 'Dealer',
  2488: 'Dealer',
  2489: 'Dealer',
  2490: 'Dealer',
  2491: 'Dealer',
  2492: 'Dealer',
  2493: 'Dealer',
  2494: 'Dealer',
  2496: 'Dealer',
  2497: 'Dealer',
  2498: 'Dealer',
  2499: 'Dealer',
  2500: 'Dealer',
  2501: 'Dealer',
  2502: 'Dealer',
  2503: 'Dealer',
  2504: 'Dealer',
  2506: 'Dealer',
  2507: 'Dealer',
  2508: 'Dealer',
  2509: 'Dealer',
  2510: 'Dealer',
  2511: 'Dealer',
  2512: 'Dealer',
  2513: 'Dealer',
  2514: 'Dealer',
  2516: 'Dealer',
  2517: 'Dealer',
  2518: 'Dealer',
  2519: 'Dealer',
  2520: 'Dealer',
  2521: 'Dealer',
  2522: 'Dealer',
  2523: 'Dealer',
  2524: 'Dealer',
  2526: 'Dealer',
  2527: 'Dealer',
  2528: 'Dealer',
  2529: 'Dealer',
  2530: 'Dealer',
  2531: 'Dealer',
  2532: 'Dealer',
  2533: 'Dealer',
  2534: 'Dealer',
  2536: 'Dealer',
  2546: 'Dealer',
  2556: 'Dealer',
  2566: 'Dealer',
  2576: 'Dealer',
  2577: 'Dealer',
  2578: 'Dealer',
  2579: 'Dealer',
  2580: 'Dealer',
  2581: 'Dealer',
  2582: 'Dealer',
  2583: 'Dealer',
  2584: 'Dealer',
  2586: 'Dealer',
  2596: 'Dealer',
  2606: 'Dealer',
  2607: 'Dealer',
  2608: 'Dealer',
  2609: 'Dealer',
  2610: 'Dealer',
  2611: 'Dealer',
  2612: 'Dealer',
  2613: 'Dealer',
  2614: 'Dealer',
  2616: 'Dealer',
  2617: 'Dealer',
  2618: 'Dealer',
  2619: 'Dealer',
  2620: 'Dealer',
  2621: 'Dealer',
  2622: 'Dealer',
  2623: 'Dealer',
  2624: 'Dealer',
  2626: 'Dealer',
  2627: 'Dealer',
  2628: 'Dealer',
  2629: 'Dealer',
  2630: 'Dealer',
  2631: 'Dealer',
  2632: 'Dealer',
  2633: 'Dealer',
  2634: 'Dealer',
  2636: 'Dealer',
  2637: 'Dealer',
  2638: 'Dealer',
  2639: 'Dealer',
  2640: 'Dealer',
  2641: 'Dealer',
  2642: 'Dealer',
  2643: 'Dealer',
  2644: 'Dealer',
  2646: 'Dealer',
  2647: 'Dealer',
  2648: 'Dealer',
  2649: 'Dealer',
  2650: 'Dealer',
  2651: 'Dealer',
  2652: 'Dealer',
  2653: 'Dealer',
  2654: 'Dealer',
  2656: 'Dealer',
  2657: 'Dealer',
  2658: 'Dealer',
  2659: 'Dealer',
  2660: 'Dealer',
  2661: 'Dealer',
  2662: 'Dealer',
  2663: 'Dealer',
  2664: 'Dealer',
  2666: 'Dealer',
  2667: 'Dealer',
  2668: 'Dealer',
  2669: 'Dealer',
  2670: 'Dealer',
  2671: 'Dealer',
  2672: 'Dealer',
  2673: 'Dealer',
  2674: 'Dealer',
  2676: 'Dealer',
  2677: 'Dealer',
  2678: 'Dealer',
  2679: 'Dealer',
  2680: 'Dealer',
  2681: 'Dealer',
  2682: 'Dealer',
  2683: 'Dealer',
  2684: 'Dealer',
  2686: 'Dealer',
  2687: 'Dealer',
  2688: 'Dealer',
  2689: 'Dealer',
  2690: 'Dealer',
  2691: 'Dealer',
  2692: 'Dealer',
  2693: 'Dealer',
  2694: 'Dealer',
  2696: 'Dealer',
  2697: 'Dealer',
  2698: 'Dealer',
  2699: 'Dealer',
  2700: 'Dealer',
  2701: 'Dealer',
  2702: 'Dealer',
  2703: 'Dealer',
  2704: 'Dealer',
  2706: 'Dealer',
  2707: 'Dealer',
  2708: 'Dealer',
  2709: 'Dealer',
  2710: 'Dealer',
  2711: 'Dealer',
  2712: 'Dealer',
  2713: 'Dealer',
  2714: 'Dealer',
  2716: 'Dealer',
  2717: 'Dealer',
  2718: 'Dealer',
  2719: 'Dealer',
  2720: 'Dealer',
  2721: 'Dealer',
  2722: 'Dealer',
  2723: 'Dealer',
  2724: 'Dealer',
  2726: 'Dealer',
  2727: 'Dealer',
  2728: 'Dealer',
  2729: 'Dealer',
  2730: 'Dealer',
  2731: 'Dealer',
  2732: 'Dealer',
  2733: 'Dealer',
  2734: 'Dealer',
  2736: 'Dealer',
  2737: 'Dealer',
  2738: 'Dealer',
  2739: 'Dealer',
  2740: 'Dealer',
  2741: 'Dealer',
  2742: 'Dealer',
  2743: 'Dealer',
  2744: 'Dealer',
  2746: 'Dealer',
  2747: 'Dealer',
  2748: 'Dealer',
  2749: 'Dealer',
  2750: 'Dealer',
  2751: 'Dealer',
  2752: 'Dealer',
  2753: 'Dealer',
  2754: 'Dealer',
  2756: 'Dealer',
  2757: 'Dealer',
  2758: 'Dealer',
  2759: 'Dealer',
  2760: 'Dealer',
  2761: 'Dealer',
  2762: 'Dealer',
  2763: 'Dealer',
  2764: 'Dealer',
  2766: 'Dealer',
  2767: 'Dealer',
  2768: 'Dealer',
  2769: 'Dealer',
  2770: 'Dealer',
  2771: 'Dealer',
  2772: 'Dealer',
  2773: 'Dealer',
  2774: 'Dealer',
  2776: 'Dealer',
  2777: 'Dealer',
  2778: 'Dealer',
  2779: 'Dealer',
  2780: 'Dealer',
  2781: 'Dealer',
  2782: 'Dealer',
  2783: 'Dealer',
  2784: 'Dealer',
  2839: 'Special',
  2844: 'Special',
  2850: 'Special',
  2851: 'Special',
  2852: 'Special',
  2853: 'Special',
  2854: 'Special',
  2880: 'Special',
  2881: 'Special',
  3201: 'GM Skills',
  3202: 'GM Skills',
  3203: 'GM Skills',
  3204: 'GM Skills',
  3205: 'GM Skills',
  3210: 'GM Skills',
  3211: 'GM Skills',
  3212: 'GM Skills',
  3213: 'GM Skills',
  3214: 'GM Skills',
  3215: 'GM Skills',
  3216: 'GM Skills',
  3217: 'GM Skills',
  3218: 'GM Skills',
  3219: 'GM Skills',
  4211: 'Soldier',
  4212: 'Soldier',
  4213: 'Soldier',
  4214: 'Soldier',
  4401: 'Muse',
  4402: 'Muse',
  4403: 'Muse',
  4601: 'Hawker',
  4602: 'Hawker',
  4603: 'Hawker',
  4604: 'Hawker',
  4605: 'Hawker',
  4606: 'Hawker',
  4607: 'Hawker',
  4608: 'Hawker',
  4609: 'Hawker',
  4801: 'Dealer',
  4802: 'Dealer',
  4803: 'Dealer',
  4804: 'Dealer',
  4805: 'Dealer',
  4806: 'Dealer',
  4807: 'Dealer',
  4808: 'Dealer',
  4809: 'Dealer',
  4811: 'Dealer',
  4812: 'Dealer',
  4813: 'Dealer',
  4814: 'Dealer',
  4815: 'Dealer',
  4816: 'Dealer',
  4817: 'Dealer',
  4818: 'Dealer',
  4819: 'Dealer',
  5000: 'Special',
  5001: 'Special',
  5500: 'Special',
  5505: 'Special',
  5506: 'Special',
  5507: 'Special',
  5508: 'Special',
  5509: 'Special',
  5510: 'Special',
  5557: 'Muse',
  5558: 'Muse',
  5559: 'Muse',
  5560: 'Muse',
  5561: 'Muse',
  5562: 'Muse',
  5563: 'Muse',
  5564: 'Muse',
  5596: 'Special',
  5601: 'Soldier',
  5602: 'Soldier',
  5603: 'Soldier',
  5604: 'Soldier',
  5605: 'Soldier',
  5606: 'Soldier',
  5607: 'Soldier',
  5608: 'Soldier',
  5701: 'Muse',
  5702: 'Muse',
  5703: 'Muse',
  5704: 'Muse',
  5705: 'Muse',
  5801: 'Hawker',
  5802: 'Hawker',
  5803: 'Hawker',
  5804: 'Hawker',
  5805: 'Hawker',
  5806: 'Hawker',
  5902: 'Dealer',
  5903: 'Dealer',
  5904: 'Dealer',
  5905: 'Dealer',
  6001: 'Muse',
  6002: 'Muse',
  6003: 'Muse',
  6004: 'Muse',
  6005: 'Muse',
  6006: 'Muse',
  6007: 'Muse',
  6008: 'Muse',
  6009: 'Muse',
  6010: 'Muse',
  6011: 'Muse',
  6012: 'Muse',
  6013: 'Muse',
  6014: 'Muse',
  6015: 'Muse',
  6016: 'Muse',
  6017: 'Muse',
  6018: 'Muse',
  6021: 'Muse',
  6022: 'Muse',
  6023: 'Muse',
  6024: 'Muse',
  6025: 'Muse',
  6026: 'Muse',
  6027: 'Muse',
  6028: 'Muse',
  6029: 'Muse',
  6031: 'Muse',
  6032: 'Muse',
  6033: 'Muse',
  6034: 'Muse',
  6035: 'Muse',
  6036: 'Muse',
  6037: 'Muse',
  6038: 'Muse',
  6039: 'Muse',
  6040: 'Muse',
  6041: 'Muse',
  6042: 'Muse',
  6043: 'Muse',
  6044: 'Muse',
  6045: 'Muse',
  6046: 'Muse',
  6047: 'Muse',
  6048: 'Muse',
  6051: 'Muse',
  6052: 'Muse',
  6053: 'Muse',
  6054: 'Muse',
  6055: 'Muse',
  6056: 'Muse',
  6057: 'Muse',
  6058: 'Muse',
  6059: 'Muse',
  6060: 'Muse',
  6061: 'Muse',
  6062: 'Muse',
  6063: 'Muse',
  6064: 'Muse',
  6065: 'Muse',
  6066: 'Muse',
  6067: 'Muse',
  6068: 'Muse',
  6071: 'Muse',
  6072: 'Muse',
  6073: 'Muse',
  6074: 'Muse',
  6075: 'Muse',
  6076: 'Muse',
  6077: 'Muse',
  6078: 'Muse',
  6079: 'Muse',
  6081: 'Muse',
  6082: 'Muse',
  6083: 'Muse',
  6084: 'Muse',
  6085: 'Muse',
  6086: 'Muse',
  6087: 'Muse',
  6088: 'Muse',
  6089: 'Muse',
  6090: 'Muse',
  6091: 'Muse',
  6092: 'Muse',
  6093: 'Muse',
  6094: 'Muse',
  6095: 'Muse',
  6096: 'Muse',
  6097: 'Muse',
  6098: 'Muse',
  6100: 'Muse',
  6101: 'Muse',
  6102: 'Muse',
  6103: 'Muse',
  6104: 'Muse',
};
